module.exports = __webpack_public_path__ + "static/media/checkmark-filled.5219fca4.svg";